import React from 'react';
import { cn } from '@/lib/utils';
import { ArrowRight } from 'lucide-react';

interface AWMSButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  icon?: boolean;
}

export const AWMSButton: React.FC<AWMSButtonProps> = ({
  variant = 'primary',
  children,
  icon = false,
  className,
  ...props
}) => {
  // Colors and hover per Figma
  const base =
    'rounded-[5px] flex items-center justify-center gap-[10px] font-bold shadow transition-colors duration-200';
  const primary = 'bg-white text-black hover:bg-secondary-grey-04';
  const secondary = 'bg-secondary-grey-01 text-white hover:bg-secondary-grey-02';

  return (
    <button
      className={cn(base, variant === 'primary' ? primary : secondary, 'px-[30px] py-[15px]', className)}
      {...props}
    >
      {children}
      {icon && <ArrowRight className="h-5 w-5" />}
    </button>
  );
};
